package com.unrealmi.site.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAboutPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("About.md", FrontMatterElement.Builder { addScalar("title", "About"); }))
}

@Page("/about")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun AboutPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("unrealmi-虚米网络") }) {
        org.jetbrains.compose.web.dom.Text("UnrealMi(虚米网络)")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("上海虚米网络科技有限公司")
        }
        org.jetbrains.compose.web.dom.Text(" 成立于2023年10月27日，是一家专注于AI应用开发的创新型科技公司。我们致力于让AI应用变得更加简单高效，服务于人们的日常生活，通过前沿的人工智能技术为用户创造更便捷、更智能的生活体验。")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("公司愿景-vision") }) {
        org.jetbrains.compose.web.dom.Text("公司愿景 Vision")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("让AI应用触手可及，让生活更加智能美好")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("我们相信AI技术不应该是高高在上的黑科技，而应该是每个人都能轻松使用的生活工具。通过简化复杂的AI技术，我们要让人工智能真正走进千家万户，成为提升生活品质的贴心助手。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("公司使命-mission") }) {
        org.jetbrains.compose.web.dom.Text("公司使命 Mission")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Make AI Simple, Make Life Better")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("我们的使命是用最简单的方式，让最先进的AI技术服务于最普通的生活场景。通过持续的技术创新和产品打磨，我们致力于消除AI应用的技术门槛，让每个人都能享受到人工智能带来的便利与美好。")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("核心能力") }) {
        org.jetbrains.compose.web.dom.Text("核心能力")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("ai核心技术") }) {
        org.jetbrains.compose.web.dom.Text("🤖 AI核心技术")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("智能算法优化")
            }
            org.jetbrains.compose.web.dom.Text("：运用先进的机器学习和深度学习技术，打造高效的AI解决方案")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("自然语言处理")
            }
            org.jetbrains.compose.web.dom.Text("：开发智能对话系统，实现人机自然交互")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("个性化AI服务")
            }
            org.jetbrains.compose.web.dom.Text("：为用户提供定制化的AI助手，满足个性化需求")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("产品开发能力") }) {
        org.jetbrains.compose.web.dom.Text("🛠️ 产品开发能力")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("快速原型设计")
            }
            org.jetbrains.compose.web.dom.Text("：敏捷开发流程，快速验证AI应用创意")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("跨平台部署")
            }
            org.jetbrains.compose.web.dom.Text("：支持多种设备和平台，确保AI应用的广泛适用性")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("用户体验优化")
            }
            org.jetbrains.compose.web.dom.Text("：专注于简化复杂的AI技术，提供直观易用的产品体验")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("应用场景创新") }) {
        org.jetbrains.compose.web.dom.Text("💡 应用场景创新")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("生活助手AI")
            }
            org.jetbrains.compose.web.dom.Text("：开发贴近日常生活的智能助手应用")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("工作效率提升")
            }
            org.jetbrains.compose.web.dom.Text("：打造提高工作效率的AI工具")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("学习与娱乐")
            }
            org.jetbrains.compose.web.dom.Text("：创造寓教于乐的AI应用体验")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("团队优势") }) {
        org.jetbrains.compose.web.dom.Text("团队优势")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("小而美的团队") }) {
        org.jetbrains.compose.web.dom.Text("小而美的团队")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("我们是一个扁平化的精英团队，没有复杂的层级结构，没有内卷文化，只有对AI技术的纯粹热爱和创造激情。每个成员都能充分发挥自己的专业能力，在轻松愉快的氛围中创造出色的产品。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("技术实力") }) {
        org.jetbrains.compose.web.dom.Text("技术实力")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("团队成员在人工智能、软件工程、产品设计等领域具有深厚的技术积累和丰富的项目经验，专注于将复杂的AI技术转化为简单易用的应用。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("用户导向") }) {
        org.jetbrains.compose.web.dom.Text("用户导向")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("我们始终以用户体验为中心，深入理解用户的真实需求，通过持续的产品迭代和优化，让AI技术真正服务于人们的日常生活。")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("发展前景") }) {
        org.jetbrains.compose.web.dom.Text("发展前景")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("随着AI技术的快速发展和普及，人工智能正在深刻改变人们的生活方式。UnrealMi凭借其在AI应用开发方面的专业能力和创新理念，致力于成为AI应用领域的优秀创新者。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("我们计划在未来几年内：")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("🚀 ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("技术深耕")
            }
            org.jetbrains.compose.web.dom.Text("：在AI算法优化和应用开发方面持续创新")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("🌟 ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("产品矩阵")
            }
            org.jetbrains.compose.web.dom.Text("：推出一系列贴近生活的AI应用产品")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("🤝 ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("开放合作")
            }
            org.jetbrains.compose.web.dom.Text("：与行业伙伴合作，共同推动AI技术的普及应用")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("🌍 ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("用户增长")
            }
            org.jetbrains.compose.web.dom.Text("：服务更多用户，让AI技术惠及更广泛的人群")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("加入我们") }) {
        org.jetbrains.compose.web.dom.Text("加入我们")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("联系邮箱")
        }
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:：contact@unrealmi.com") {
            org.jetbrains.compose.web.dom.Text("：contact@unrealmi.com")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("我们在寻找什么样的人") }) {
        org.jetbrains.compose.web.dom.Text("🌟 我们在寻找什么样的人？")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("AI技术爱好者")
            }
            org.jetbrains.compose.web.dom.Text("：对人工智能充满好奇心，渴望用技术改变世界")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("产品思维者")
            }
            org.jetbrains.compose.web.dom.Text("：能够将复杂的技术转化为用户喜爱的产品")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("终身学习者")
            }
            org.jetbrains.compose.web.dom.Text("：保持开放心态，拥抱新技术和新挑战")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("团队协作者")
            }
            org.jetbrains.compose.web.dom.Text("：享受与优秀伙伴一起创造的过程")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("我们能给你什么") }) {
        org.jetbrains.compose.web.dom.Text("💫 我们能给你什么？")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("纯粹的技术环境")
            }
            org.jetbrains.compose.web.dom.Text("：专注于技术本身，远离办公室政治")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("扁平的团队结构")
            }
            org.jetbrains.compose.web.dom.Text("：每个人的声音都被听见，每个想法都被重视")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("充分的成长空间")
            }
            org.jetbrains.compose.web.dom.Text("：在AI前沿领域快速成长，积累宝贵经验")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("有意义的工作")
            }
            org.jetbrains.compose.web.dom.Text("：参与创造真正改善人们生活的AI应用")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("一起改变世界") }) {
        org.jetbrains.compose.web.dom.Text("🚀 一起改变世界")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("如果你相信AI技术能够让世界变得更美好，如果你想在一个充满激情和创造力的团队中发挥才能，如果你渴望用代码书写未来——那么，UnrealMi就是你的舞台。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("我们欢迎有志于AI技术发展的投资者、合作伙伴和人才加入我们，共同创造AI应用的美好未来。")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("让我们一起Make The UnrealMi World Possible！")
        }
    }
}
